import { useDispatch, useSelector } from 'react-redux';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { replaceDomainForCacheKey, useErrorOnNotOkFetchye } from '@americanexpress/fetchye-amex';
import { getHasAuthLoadedSelector, getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import {
  getCardOffersPath,
  getEligibleCardOffersOneCmsPath,
} from '../selectors/getHomeSelectors';
import { hasHomePageCardOffersRule } from '../constants/featureRulesConstants';
import { getOneCMSDomainSelector } from '../selectors/getDomainSelectors';
import { queryHomepageCardOffers } from '../thunks/loadHomepageCardOffersThunk';
import { MODULE_NAME } from '../constants/modules';
import { validateEligibleCardOffersPath } from '../utils/personaUtils';

export const reportingfn = ({ key, error }) => ({
  moduleID: MODULE_NAME,
  component: 'useHomepageCardOffers',
  fetch: {
    url: key,
    status: error?.status,
  },
});

export const useHomepageCardOffers = () => {
  const hasHomePageCardOffers = useConditionalFeature(hasHomePageCardOffersRule);

  const eligibleCardOffersOneCmsPath = useSelector(getEligibleCardOffersOneCmsPath);
  const oneCMSInternetUrl = useSelector(getOneCMSDomainSelector);

  const persona = useSelector(getCardOffersPath);
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const hasAuthLoaded = useSelector(getHasAuthLoadedSelector);
  const isValidCardOffers = validateEligibleCardOffersPath(
    isLoggedIn,
    hasAuthLoaded,
    eligibleCardOffersOneCmsPath
  );
  const dispatch = useDispatch();

  let homepageCardOffersStatus = 'loading';
  let homepageCardOffersError = false;
  if (global.BROWSER && hasHomePageCardOffers) {
    const {
      error,
      status,
    } = dispatch(queryHomepageCardOffers);
    homepageCardOffersStatus = status;
    homepageCardOffersError = error;
  }

  const loadingHomepageCardOffers = homepageCardOffersStatus === 'loading';
  const oneCMSUrl = `${oneCMSInternetUrl}/${eligibleCardOffersOneCmsPath}`;

  const isHomepageCardOffersLoading = hasHomePageCardOffers
    && loadingHomepageCardOffers
    && !homepageCardOffersError;

  const defer = !hasHomePageCardOffers
      || (isHomepageCardOffersLoading || homepageCardOffersError)
      || !isValidCardOffers;

  const { data, isLoading: fetchyeLoading, error: fetchyeError } = useErrorOnNotOkFetchye(
    oneCMSUrl,
    {
      defer,
      mapKeyToCacheKey: replaceDomainForCacheKey(`oneCMS/cardOffers/${persona}`),
    },
    reportingfn
  );

  const isWaitingForFetchyeRunAsync = hasHomePageCardOffers
    && !data
    && !fetchyeLoading
    && !fetchyeError
    && !isHomepageCardOffersLoading;

  return {
    data,
    isLoading: fetchyeLoading || isWaitingForFetchyeRunAsync || isHomepageCardOffersLoading,
    error: fetchyeError,
  };
};
